module.exports = __webpack_public_path__ + "static/media/Control_4_Thermocycler.a2b3d9a9.svg";